var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderClosed16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6h14v3a5 5 0 01-5 5H6a5 5 0 01-5-5V6z",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25A2.75 2.75 0 0112.25 14h-8.5A2.75 2.75 0 011 11.25v-7.5a1.75 1.75 0 011.606-1.744L2.75 2h3.132c.612 0 1.175.32 1.491.835l.074.132.099.198a.607.607 0 00.445.327l.098.008h5.161a1.75 1.75 0 011.744 1.606L15 5.25zM13.5 7.5h-11v3.75c0 .647.492 1.18 1.122 1.244l.128.006h8.5c.69 0 1.25-.56 1.25-1.25V7.5zm-7.618-4H2.75a.25.25 0 00-.243.193L2.5 3.75V6h11v-.75a.25.25 0 00-.193-.243L13.25 5H8.089a2.107 2.107 0 01-1.803-1.016l-.082-.149-.098-.197a.25.25 0 00-.168-.132L5.882 3.5z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderClosed16);
export default __webpack_public_path__ + "static/media/folder-closed-16.2fd23977.svg";
export { ForwardRef as ReactComponent };